export default __webpack_public_path__ + "static/media/demoMapLarge.b1182621.svg";